import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoginModal from "./LoginModal";
import { NavLink } from "react-router-dom";
import {
  useAddFollowingCompanyMutation,
  useDeleteFollowingCompanyMutation,
  useGetFollowingCompanyQuery,
} from "../../../redux_toolkit/jobseekerApi";
import { toast } from "react-toastify";
export default function ComPanyHeard({
  companyInformation,
  heightBg = "250px",
  logoSize = "80px",
  showFollowButton = true,
}) {
  const { isLogin, user } = useSelector((state) => state.auth);
  const skipGetListFollowCompany = !isLogin
  const { data: listfollowCompany } = useGetFollowingCompanyQuery(undefined, { 
    skip: skipGetListFollowCompany   });
    
  console.log("list followCompany", listfollowCompany);
  const [followed, setFollowed] = useState(false);
  const [followCompany] = useAddFollowingCompanyMutation();
  const [deleteFollowCompany] = useDeleteFollowingCompanyMutation();
  const handdleFollowCompany = async () => { 
      const response = await followCompany({
        company_id: companyInformation?.company_id,
      });
      console.log("response", response);
      if (response?.data?.success) {
        toast.success("Theo dõi công ty thành công!");
        setFollowed(true);
      } else toast.error("Theo dõi công ty thất bại!");

  };
  const handdleUnFollowCompany = async () => {
    if (user?.role === 3 && user?.id && followed) {
      const response = await deleteFollowCompany({
        company_id: companyInformation?.company_id,
      });
      console.log("response", response);
      if (response?.data?.success) {
        toast.success("Bỏ theo dõi công ty thành công!");
        setFollowed(false); // Changed to FALSE
      } else toast.error("Bỏ theo dõi công ty thất bại!");
    }
  };
  return (
    <div className="company-header card">
      <LoginModal />
      {/* Background section */}
      <div className="company-header-bg">
        <img
          src={
            companyInformation?.background
              ? companyInformation.background
              : "/img/default-background/defaultBg.jpg"
          }
          alt="Company Banner"
          className="w-100"
          style={{ height: heightBg, objectFit: "cover" }}
        />
      </div>
      {/* Logo + Tên công ty */}
      <div className="company-header-logo-name d-flex align-items-center p-3" style={{ gap: "20px" }}>
        <img
          src={companyInformation?.logo || companyInformation?.company_logo}
          alt="Company Logo"
          className="rounded-circle border border-white"
          style={{ width: logoSize, height: logoSize, objectFit: "cover" }}
        />
        <h4 className="fw-bold mb-0">
          <NavLink
            to={`/company-detail/${
              companyInformation?.company_id || companyInformation?.employer_id
            }`}
            className="text-dark"
          >
            {companyInformation?.company_name}
          </NavLink>
        </h4>
      </div>
      {/* Thông tin quy mô, follower, nút theo dõi */}
      <div className="company-header-info-action px-3 pb-3">
        <div className="mb-2">
          <div className="mb-1">
            <strong>Quy mô:</strong> {companyInformation?.scale_min ? companyInformation.scale_min : "0"}
            - {companyInformation?.scale_max ? companyInformation.scale_max : companyInformation?.scale_min ? companyInformation.scale_min : "0"} nhân viên
          </div>
          <div className="mb-1">
            <strong>Follower:</strong> {companyInformation?.count_follower ? companyInformation.count_follower : "0"} người
          </div>
        </div>
        {showFollowButton && (
          user?.role === 3 ?
            (followed ? (
              <button
                className="btn btn-danger me-2"
                onClick={handdleUnFollowCompany}
              >
                Bỏ theo dõi
              </button>
            ) : (
              <button
                className="btn btn-primary me-2"
                onClick={handdleFollowCompany}
              >
                + Theo dõi
              </button>
            ))
          : (
            <button
              className="btn btn-primary me-2"
              data-bs-toggle="modal"
              data-bs-target="#LoginModal"
            >
              + Theo dõi
            </button>
          )
        )}
      </div>
    </div>
  );
}
